import React, { useEffect, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import ListView from 'src/layouts/ListView';
import { Helmet } from 'react-helmet';
import ActiveAssessments from './ActiveAssessments';
import CompletedAssessments from './CompletedAssessment';
import { useAssessmentTotal } from './hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import ScrollToTopButton from 'src/pages/Organization/public/Journal/SubmissionUpload/components/common/ScrollToTopButton';

const TABS = {
  ACTIVE: 'Active Assessments',
  COMPLETED: 'Completed Assessments'
} as const;
type Tab = (typeof TABS)[keyof typeof TABS];

const renderTab = (tab: Tab) => {
  switch (tab) {
    case TABS.ACTIVE:
      return <ActiveAssessments />;
    case TABS.COMPLETED:
      return <CompletedAssessments />;
    default:
      return null;
  }
};

const MyAssessments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const assessmentStatus = searchParams.get('status') || ''
  const selectedTab = assessmentStatus ? assessmentStatus.split('-')[0]?.toUpperCase() : ''

  const [activeTab, setActiveTab] = useState<Tab>(selectedTab === 'COMPLETED' ? TABS[selectedTab] : TABS.ACTIVE);
  const { data: assessmentListTotal } = useAssessmentTotal()

  const getTabLabel = (tab: Tab) => {
    switch (tab) {
      case TABS.ACTIVE:
        return `${TABS.ACTIVE} (${assessmentListTotal?.activeTotal || 0})`;
      case TABS.COMPLETED:
        return `${TABS.COMPLETED} (${assessmentListTotal?.completedTotal || 0}) `;
      default:
        return tab;
    }
  };

  useEffect(() => {
    assessmentStatus && navigate(`/app/assessments?${searchParams.toString()}`)
    setActiveTab(selectedTab === 'COMPLETED' ? TABS[selectedTab] : TABS.ACTIVE)
  }, [assessmentStatus])

  return <Box
    id="scrollable-wrapper"
    height="100%"
    overflowY="auto"
    overflowX="hidden"
  >
    <Box paddingTop={10} paddingLeft={5} paddingRight={5} minHeight="100%">
      <Flex
        flexDirection="column"
        width="100%"
        alignItems="flex-start"
        gap={4}
      >
        <Helmet>
          <title>Assessments</title>
        </Helmet>
        <Box textStyle="headingTitle" width="100%">
          <Flex
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Text>Assessments</Text>
          </Flex>
        </Box>
        <Flex
          gap={2}
          alignItems="center"
          borderColor="neutralPrimaryBorder"
          borderStyle="solid"
          mb={2}
        >
          {Object.values(TABS).map(tab => (
            <ListView.Tab
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                navigate(`/app/assessments?status=${tab.split(" ").join("-").toLocaleLowerCase()}`)
              }}
              isActive={activeTab === tab}
            >
              {getTabLabel(tab)}
            </ListView.Tab>
          ))}
        </Flex>
        {renderTab(activeTab)}
      </Flex>
    </Box>
    <ScrollToTopButton />
  </Box>
};

export default MyAssessments;